import { render } from "./ai-global-prompts.vue?vue&type=template&id=04f59ac0"
import script from "./ai-global-prompts.vue?vue&type=script&lang=js"
export * from "./ai-global-prompts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__